import { appointment, ActionType } from "./types";

const setAppointment = (data: appointment) => {
  return {
    type: ActionType.SET_APPOINTMENT,
    payload: data,
  };
};

export default setAppointment;
